<template>
  <section class="ctn">
    <header class="header left">
      <router-link class="paper-action" :to="{ path: '/employees' }"><heim-icon icon="arrow-back"></heim-icon><span>{{ $t('back') }}</span></router-link>
    </header>
    <heim-card>
      <header class="header left">
        <h1>{{ $t('info') }} {{ $t('projectPrice') }}</h1>
      </header>
      <main>
        <form @submit.prevent="handleForm">
          <div class="row">
            <span class="label">{{ $t('info')  + ' *' }}</span>
            <div class="inputs">
              <datepicker
                :label="$t('creationDate')"
                type="date"
                name="date"
                input-class="paper-input"
                wrapper-class="heim-input"
                :minimum-view="'month'"
                :maximum-view="'month'"
                :language="language"
                v-model="date"
                v-validate="'required'"
                :disabled="true"
                :placeholder="$t('selectDate')"
              ></datepicker>
              <span class="help is-danger" v-show="errors.has('date')"><heim-icon class="icon" icon="error"></heim-icon> {{ errors.first('date') }}</span>

              <heim-input :label="$t('dailySalary') + ' *'" name="salary" v-model="price" v-validate="'required'"></heim-input>
              <span class="help is-danger" v-show="errors.has('salary')"><heim-icon class="icon" icon="error"></heim-icon> {{ errors.first('salary') }}</span>
            </div>
          </div>
          <footer>
            <heim-button :disabled="errors.any()" type="submit">{{ $t('save') }}</heim-button>
          </footer>
        </form>
      </main>
    </heim-card>
  </section>
</template>

<script>
import HeimInput from "@/components/form/input/text/heim-input.vue";
import HeimTextarea from "@/components/form/input/text/heim-textarea.vue";
import HeimToggleButton from "@/components/form/input/toggle/heim-toggle-button.vue";
import HeimSelect from "@/components/form/input/select/heim-select.vue";
import HeimButton from "@/components/form/button/heim-button.vue";
import HeimCard from "@/components/layout/card/heim-card.vue";
import HeimIcon from "@/components/icon/heim-icon.vue";
import Datepicker from "vuejs-datepicker";
import {fr, en} from "vuejs-datepicker/dist/locale";
import Places from "vue-places";

import { mapState } from "vuex";
export default {
  name: "EmployeesEdit",
  components: {
    HeimInput,
    HeimTextarea,
    HeimToggleButton,
    HeimSelect,
    HeimButton,
    HeimCard,
    HeimIcon,
    Datepicker,
    Places
  },
  mounted() {
    if (this.password) {
      this.$store.dispatch("getPriceInfo", { id: this.$route.params.id, password: this.password });
    } else {
      this.$router.push({ path: "/employees" });
    }
  },
  data() {
    return {
      nameId: "",
      date: "",
      price: ""
    };
  },
  computed: {
    ...mapState({ lang: state => state.lang }),
    ...mapState({ password: state => state.employeePwd }),
    ...mapState({ priceData: state => state.employeesState.price[0] }),
    language() {
      if (this.lang == "en") return en;
      else return fr;
    }
  },
  methods: {
    async handleUpdate() {
      const data = await this.$store.dispatch("updateEmployee", {
        nameId: this.priceData.user_id,
        salary: this.price,
        date: this.date.getTime(),
        password: this.password
      });
      return data;
    },
    handleForm() {
      this.$validator.validateAll().then(async result => {
        if (result) {
          const data = await this.handleUpdate();
          if (data) {
            this.$store.dispatch("setToastMessage", {
              message: "Les données ont été enregistrées"
            });
            this.$store.dispatch("setToastMode", {});
            this.$store.dispatch("setOpenToast", { opened: true });
            this.$router.push({ path: `/employees` });
          }
        }
      });
    }
  },
  watch: {
    priceData(newPrice, oldPrice) {
      this.date = new Date(newPrice.date);
      this.price = newPrice.price;
    }
  }
};
</script>

<style>
input.paper-input,
.ap-input {
  background: var(--heim-grey-color);
  width: 100%;
  display: block;
  padding: 0.3em 0.4em;
  font-size: 0.9em;
  border-radius: 3px;
  border: solid 1px #ededed;
  outline: none;
  transition: box-shadow 0.3s var(--heim-transition);
}

input.paper-input:hover,
input.paper-input:focus {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.heim-input[icon] input.paper-input {
  padding-right: 32px;
}

.date-input {
  margin-bottom: 20px;
}

.heim-input {
  max-width: 32em;
}

.heim-input input {
  width: 100%;
}

.search-location {
  display: block;
  margin: 0 auto;
  margin-top: 5vw;
  font-size: 20px;
  font-weight: 400;
  outline: none;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 10px;
}
</style>

<style scoped>
.toggle-box {
  font-size: 0.8em;
  color: rgba(0, 0, 0, 0.65);
  font-weight: 500;
  display: flex;
  align-items: center;
}
.toggle-box .label {
  display: inline-block;
  margin-bottom: 0.6em;
}

.heim-input .label {
  display: inline-block;
  font-size: 0.8em;
  color: rgba(0, 0, 0, 0.65);
  margin-bottom: 0.1em;
  font-weight: 500;
}

.ap-input {
  background: var(--heim-grey-color);
  width: 100%;
  display: block;
  padding: 0.3em 0.4em;
  font-size: 0.9em;
  border-radius: 3px;
  border: solid 1px #ededed;
  outline: none;
  transition: box-shadow 0.3s var(--heim-transition);
}
</style>
